// extracted by mini-css-extract-plugin
module.exports = {"data_box":"databox_data_box__3-OEn","number":"databox_number__7zAT_"};